export type TPlanesExternos =
    {
        type: string;
        text: string;
    };

// Valor que se muestra cuando Wealth Reader no informa el dato.
export const EMPTY_VALUE = "—";

export const DATA_RECEIVED_TITLES =
{
    summary: "Resumen",
    portfolios: "Carteras",
    composition: "Composición",
    accounts: "Cuentas",
    holder: "Titular"
};

export const DATA_RECEIVED_SUMMARY_LABELS =
{
    portfoliosCount: "Nº de carteras",
    portfoliosValue: "Valor total",
    accountsCount: "Nº de cuentas",
    accountsBalance: "Saldo total"
};

export const DATA_RECEIVED_PORTFOLIO_LABELS =
{
    totalValue: "Valoración",
    weightedReturn: "Rentabilidad Ponderada",
    annualizedVolatility: "Volatilidad",
    yield: "Yield",
    contributions: "Aportaciones",
    withholdings: "Retenciones",
    contractingDate: "Contratación"
};

export const DATA_RECEIVED_COMPOSITION_HEADERS =
{
    isin: "ISIN",
    name: "Nombre",
    currency: "Divisa",
    weighting: "Peso",
    shares: "Participaciones",
    price: "Precio",
    totalAmount: "Importe"
};

export const DATA_RECEIVED_ACCOUNT_HEADERS =
{
    name: "Nombre",
    code: "Código",
    currency: "Divisa",
    available: "Disponible",
    current: "Actual"
};

export const DATA_RECEIVED_HOLDER_LABELS =
{
    name: "Nombre",
    document: "Documento",
    email: "Email",
    phone: "Teléfono",
    address: "Dirección"
};

export const DATA_RECEIVED_EMPTY_MESSAGES =
{
    noPortfolios: "Wealth Reader no ha devuelto ninguna cartera.",
    noComposition: "Esta cartera no tiene posiciones informadas.",
    noAccounts: "Wealth Reader no ha devuelto ninguna cuenta."
};

export const PORTFOLIO_SUBTYPE_LABELS: Record<string, string> =
{
    "funds": "Fondos",
    "stocks": "Acciones",
    "pension-plans": "Planes de pensiones",
    "alternative-investments": "Inversiones alternativas"
};

export const PLANES_EXTERNOS_OWNERS_PREFIX = "Titulares:";

export const PLANES_EXTERNOS_DESCRIPTION: TPlanesExternos[] =
    [
        {
            type: "plain",
            text: "Nada más fácil que traerte tus inversiones al método de Ahorro Periódico."
        },
        {
            type: "plain",
            text: "Importante. Las claves de tu entidad no se almacenan. Se genera una clave de acceso única de sólo lectura que puedes revocar en tu entidad en cualquier momento. La seguridad es nuestra prioridad. Toda la comunicación es cifrada."
        },
        {
            type: "bold",
            text: "Al traerte tus inversiones puedes decidir si quieres mantener algún fondo en tu nueva cartera de ahorro periódico. También te avisaremos si tenemos clases de fondos más baratas para que puedas ahorrarte dinero."
        },
        {
            type: "plain",
            text: "Nuestro método utiliza las clases de los fondos más baratas, las clases limpias, y si quisieras mantener algún fondo con retrocesiones cada 3 meses te las devolveríamos."
        },
        {
            type: "plain",
            text: "El Ahorro periódico se basa en la plataforma de inversión IronIA Fintech, podrás acceder a ella para gestionar tu contrato."
        }
    ];